export default {
  'aws.title': 'คำสั่งซื้อ Amazon',
  'aws.business': 'ผลิตภัณฑ์/รหัสคำสั่งซื้อ',
  'aws.orderStatus': 'สถานะคำสั่งซื้อ',
  'aws.aswStatus': 'สถานะการสมัครสมาชิก Amazon',
  'aws.orderInfo': 'ข้อมูลคำสั่งซื้อ',
  'aws.expireTime': 'เวลาหมดอายุ',
  'aws.createTime': 'เวลาสร้าง',
  'aws.pending': 'รอการยืนยัน',
  'aws.unbind': 'รอการเชื่อมต่อ',
  'aws.bound': 'เชื่อมต่อแล้ว',
  'aws.cancelled': 'ยกเลิกแล้ว',
  'aws.activeText': 'จะเปิดใช้งานหลังจาก {time}',
  'aws.operate': 'การดำเนินการ',
  'aws.bindTips': 'คำสั่งซื้อรอการเปิดใช้งาน ไม่สามารถดำเนินการได้ในขณะนี้',
  'aws.bind': 'เชื่อมต่อ',
  'aws.engageLabOrder': 'คำสั่งซื้อ EngageLab',
  'aws.whatsapp.recharge': 'เติมเงิน',
  'aws.whatsapp.recharge.price': 'จำนวนเงินที่เติม',
  'aws.apppush.dataCenter': 'ศูนย์ข้อมูล',
  'aws.apppush.dau': 'DAU',
  'aws.apppush.vip': 'ระยะเวลา VIP',
  'aws.email.tips': 'แพ็คเกจอีเมล / ปริมาณข้อมูล / IP เฉพาะ',
  'aws.email': 'จำนวนอีเมล',
  'aws.email.ip': 'จำนวน IP เฉพาะ',
  'aws.email.flow': 'เติมปริมาณข้อมูล',
  'aws.choose.service': 'เลือกบริการ EngageLab',
  'aws.choose.organization': 'องค์กร',
  'aws.choose.nodata': 'ไม่มีข้อมูลแอปพลิเคชัน',
  'aws.choose.whatsapp': 'บัญชีธุรกิจ WhatsApp',
  'aws.choose.app': 'แอปพลิเคชัน',

  'aws.order.title': 'เชื่อมต่อคำสั่งซื้อ Amazon',
  'aws.order.information': 'ข้อมูลคำสั่งซื้อ Amazon',
  'aws.order.id': 'รหัสคำสั่งซื้อ',
  'aws.order.product': 'ประเภทผลิตภัณฑ์',
  'aws.bind.success': 'เชื่อมต่อสำเร็จ',
  'aws.bind.modal.create': 'สร้าง{appName}',
  'aws.month': '{number} เดือน',
  'aws.allBusiness': 'ผลิตภัณฑ์ทั้งหมด',
  'aws.order.status': 'สถานะคำสั่งซื้อ',
  'aws.aswStatus.refunded': 'คืนเงินแล้ว',
  'aws.aswStatus.expired': 'หมดอายุแล้ว',
  'aws.aswStatus.subscribed': 'สมัครสมาชิกแล้ว',
  'aws.aswStatus.upgraded': 'อัปเกรดแล้ว',
  'aws.aswStatus.renewed': 'ต่ออายุอัตโนมัติ',
  'aws.aswStatus.cancelled': 'ยกเลิกแล้ว',
  'aws.aswStatus.refunded.tips':
    'คำสั่งซื้อนี้ได้ขอคืนเงินจาก Amazon แล้ว กรุณาติดต่อฝ่ายธุรกิจเพื่อดำเนินการ',
  'aws.aswStatus.upgraded.tips':
    'คำสั่งซื้อนี้ได้ทำการอัปเกรดที่ Amazon หากต้องการรับสิทธิ์หลังการอัปเกรดที่ EngageLab กรุณาติดต่อฝ่ายขายเพื่อช่วยดำเนินการ แพ็คเกจหลังการอัปเกรดมีดังนี้:',
  'aws.bindTips.cancelled': 'คำสั่งซื้อถูกยกเลิกที่ Amazon แล้ว',
  'aws.bindTips.unbind': 'คำสั่งซื้อที่ Amazon {status} กรุณาติดต่อฝ่ายธุรกิจเพื่อดำเนินการ',
  'aws.bindTips.unbind.status.refunded': 'คืนเงิน',
  'aws.bindTips.unbind.status.expired': 'หมดอายุ',
  'aws.bindTips.unbind.status.upgraded': 'อัปเกรด',
  'aws.bindTips.unbind.status': 'คืนเงิน/หมดอายุ/อัปเกรด',
  'aws.nodata': 'ไม่มีข้อมูล',
  'aws.jumpEmail':
    'กรุณาไปที่<a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a>เพื่อกำหนดค่าโดเมน',
};
